import { isInTextField } from "@design-system/overlay/textFields";

/**
 * Text fields, selects, and editors keep their own keys; the grid ignores
 * them. Checkboxes, radios, buttons, sliders, and color pickers aren't
 * editable: table keys still work there, as on Board and Menu.
 */
export const isEditableTarget = (target: EventTarget | null) =>
    target instanceof HTMLElement &&
    (target.isContentEditable ||
        isInTextField(target) ||
        target.closest("select") !== null);
